<template>
    <el-dialog
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        :visible.sync="applyDialogVisible"
        center
        class="detail-dialog-container"
        width="50%">
        <div class="dialog-container flex flex-direction padding">
            <div class="dialog-header flex">
                <div class="dialog-title flex-sub">服务内容</div>
                <i class="dialog-close el-icon-close" @click="cancel"></i>
            </div>
            <div class="dialog-content flex flex-direction">
                <div v-for="(item,index) in scontents" :key="index" class="title"
                     @click="onItem(item)">
                    {{ item.server_title }}
                </div>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                class="self-end"
                layout="prev, pager, next, jumper"
                @current-change="init">
            </el-pagination>
        </div>
        <more-service-detail-dialog :id="cur_id" :apply-dialog-visible="detailDialogVisible" @watchState="watchState"></more-service-detail-dialog>
    </el-dialog>
</template>

<script>
import MoreServiceDetailDialog from "./MoreServiceDetailDialog";
import {getMemberServiceContents} from "@/api/data";

export default {
    name: "MoreServiceDialog",
    components: {MoreServiceDetailDialog},
    props: {
        applyDialogVisible: {
            type: Boolean,
            default: false
        },
        oid: { //详情ID
            type: Number,
        },
        id: { //详情ID
            type: Number,
        }
    },
    data() {
        return {
            scontents: [],
            page: 1,
            limit: 8,
            total: 0,
            detailDialogVisible: false,
            cur_id: 0
        }
    },
    created() {
    },
    methods: {
        async init() {
            let _data = await getMemberServiceContents(this.oid, this.id, this.page, this.limit)
            this.scontents = _data.data
            this.total = _data.total_number
        },
        cancel() {
            this.$emit('watchState', false)
        },
        onItem(item) {
            this.cur_id = item.id
            this.detailDialogVisible = true
        },
        watchState() {
            this.detailDialogVisible = false
        }

    },
    watch: {
        id() {
            this.init()
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-dialog-container {
    .dialog-container {
        .dialog-header {
            height: 55px;

            .dialog-title {
                font-size: 18px;
                font-weight: bold;
                color: #0a2240;
            }

            .dialog-close {
                font-size: 21px;
                color: #0a2240;
                font-weight: bold;
                cursor: pointer;
            }
        }

        .dialog-content {
            height: 505px;
            padding: 0 20px;

            .title {
                font-size: 18px;
                line-height: 56px;
                color: #333333;
                border-bottom: 1px solid #dadada;
                padding-left: 20px;
                position: relative;
                cursor: pointer;

                &:after {
                    position: absolute;
                    content: '';
                    left: 0;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 10px;
                    height: 10px;
                    background-color: #333333;
                    border-radius: 10px;
                }
            }
        }
    }
}
</style>